import { Divider as MaterialDivider } from '@mui/material';
import i18next from 'i18next';
import React from 'react';

import type { DividerProps } from './Divider.types';

// eslint-disable-next-line import/no-named-as-default-member
const t = i18next.getFixedT.bind(i18next)(null, 'core', 'divider');

/**
 * The Divider
 *
 * @version [AIV]{version}[/AIV]
 * @author [SFP](https://gitlab.sfp.berlin/products/sparkasse.de/portals)
 * @see [https://styleguide.sparkasse.de/document/69#/ui-komponenten/divider]
 */
export const Divider: React.FC<DividerProps> = ({ variant, ...props }: DividerProps) => {
  if (variant === 'listicle') {
    const { displayNumber, ...rest } = props;
    return (
      <MaterialDivider
        variant={variant}
        role="presentation"
        aria-label={displayNumber ? `${t('step')} ${displayNumber}` : ''}
        {...rest}
      >
        <span aria-hidden={true}>{displayNumber}</span>
      </MaterialDivider>
    );
  }

  return <MaterialDivider role="separator" variant={variant} aria-hidden={true} {...props} />;
};
